/**
 * Partner logók section -- Swiper carousel init.
 * Csak akkor fut ha van .partner-logok__swiper és Swiper betöltődött.
 */
(function () {
  'use strict';

  var swipers = document.querySelectorAll('.partner-logok__swiper');
  if (!swipers.length || typeof Swiper === 'undefined') return;

  swipers.forEach(function (el) {
    var colsD = parseInt(el.getAttribute('data-cols-desktop'), 10) || 5;
    var colsM = parseInt(el.getAttribute('data-cols-mobile'), 10)  || 3;

    new Swiper(el, {
      loop: true,
      speed: 600,
      autoplay: { delay: 3000, disableOnInteraction: false, pauseOnMouseEnter: true },
      spaceBetween: 24,
      slidesPerView: colsM,
      breakpoints: {
        768:  { slidesPerView: Math.min(colsD, colsM + 1) },
        992:  { slidesPerView: colsD }
      }
    });
  });
})();
